var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question"},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark"}},[_c('div',{staticClass:"text-center",attrs:{"slot":"content"},slot:"content"},[_vm._t("default")],2),_c('i',{staticClass:"icon question"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }